import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Dashboard from '../pages/tm/dashboard';
import Investigation from '../pages/tm/investigation';
import InvestigationDetail from '../pages/tm/investigationDetail';
import Settings from '../pages/settings';

import { tmHasPermission } from '../util';
import { getItemFromLocalStorage } from '../util/localStorageUtils';
import { ROUTE_AMLS_TM_SAM } from '../pages/constants/globalConstants';
import {
  TM_TAB_LIST,
  TM_TAB_PAGEID_LIST
} from '../pages/constants/tmConstants';
import { getSelectedResources } from '../util/resourceManager';
import NotFoundPage from '../pages/common/NotFoundPage';
import { getCurrentAppByPath } from '../pages/app/appUtils';
import SafeRedirect from './SafeRedirect';

const { tmResources } = getSelectedResources();
const TMSettings = () => (
  <Settings
    title="Global Setting for Transaction Monitoring"
    tmTabList={TM_TAB_LIST}
    tmTabPageIdList={TM_TAB_PAGEID_LIST}
    GlobalSettingPageType={'TM'}
  />
);

export default (authentication) => {
  //protect route by user role
  const RestrictedRender = (Component) => {
    return tmHasPermission(authentication) ? (
      <Component></Component>
    ) : (
      <NotFoundPage />
    );
  };

  let riskViewPermitted = false;
  let alertsListingPermitted = false;
  let investigationPagePermitted = false;
  let globalSettingsPermitted = false;
  let trmDashboardPermitted = false;
  let homeUrl = null;

  const investigationRoute = `${ROUTE_AMLS_TM_SAM}/investigation`;
  const dashboardRoute = `${ROUTE_AMLS_TM_SAM}/dashboard`;
  const settingsRoute = `${ROUTE_AMLS_TM_SAM}/settings`;

  if (
    authentication &&
    Array.isArray(authentication.data) &&
    authentication.data.length > 0
  ) {
    // list of Attributes
    const listOfAttributes = authentication.data;

    listOfAttributes.map((attribute) => {
      const resource = attribute.details?.resource;
      const resourceCode = resource?.resourceCode;
      const scopes = resource?.operations;
      const matchesResource = (code) =>
        resourceCode === code || (scopes && scopes.includes(code));

      if (matchesResource(tmResources.APP_3_RESOURCE_UI_TM_IAD_FULLACCESS)) {
        trmDashboardPermitted = true;
      }

      if (matchesResource(tmResources.APP_3_RESOURCE_UI_TM_ALERT_LIST_ALERTS)) {
        alertsListingPermitted = true;
      }

      if (
        matchesResource(tmResources.APP_3_RESOURCE_UI_TM_ALERT_LIST_ANOMALIES)
      ) {
        alertsListingPermitted = true;
      }

      if (
        matchesResource(tmResources.APP_3_RESOURCE_UI_TM_INVESTIGATION_PAGE)
      ) {
        investigationPagePermitted = true;
      }

      if (matchesResource(tmResources.APP_3_RESOURCE_UI_TM_DASHBOARD)) {
        riskViewPermitted = true;
      }

      if (
        matchesResource(tmResources.APP_3_RESOURCE_UI_TM_GLOBAL_SETTINGS) &&
        getItemFromLocalStorage('settings-enabled') === 'true'
      ) {
        globalSettingsPermitted = true;
      }
    });

    if (trmDashboardPermitted) {
      homeUrl = '/app/trm/dashboard';
    } else if (investigationPagePermitted) {
      homeUrl = investigationRoute;
    } else if (riskViewPermitted) {
      homeUrl = dashboardRoute;
    }
  }

  const nameSpace = getCurrentAppByPath(location.pathname);

  const routes = (
    <Switch>
      {/* Set the route for the landing page */}
      {homeUrl ? (
        <Route
          exact
          path="/app"
          render={({ history }) => (
            <SafeRedirect to={homeUrl} history={history} />
          )}
        />
      ) : null}

      {homeUrl && (
        <Route
          exact
          path={ROUTE_AMLS_TM_SAM}
          render={({ history }) => (
            <SafeRedirect to={homeUrl} history={history} />
          )}
        />
      )}

      {riskViewPermitted ? (
        <Route
          exact
          path={dashboardRoute}
          render={() => {
            return RestrictedRender(Dashboard);
          }}
        />
      ) : null}

      {alertsListingPermitted ? (
        <Route
          exact
          path={investigationRoute}
          render={() => {
            return RestrictedRender(Investigation);
          }}
        />
      ) : null}

      {investigationPagePermitted ? (
        <Route
          exact
          path={`${investigationRoute}/:alertId`}
          component={InvestigationDetail}
        />
      ) : null}

      {globalSettingsPermitted ? (
        <Route
          exact
          path={settingsRoute}
          render={() => {
            return RestrictedRender(TMSettings);
          }}
        />
      ) : null}
      {/* TM-IAD / Fraud roles have no TM-SAM landing page; their home lives under /app/trm */}
      {!homeUrl && (
        <Route
          exact
          path={ROUTE_AMLS_TM_SAM}
          render={({ history }) => (
            <SafeRedirect to="/app/trm" history={history} />
          )}
        />
      )}
      {nameSpace !== 'trm' ? <Route path="*" component={NotFoundPage} /> : null}
    </Switch>
  );
  return routes;
};
